import { render } from "./exportedSalesTable.vue?vue&type=template&id=e2d3c9c4&scoped=true"
import script from "./exportedSalesTable.vue?vue&type=script&lang=js"
export * from "./exportedSalesTable.vue?vue&type=script&lang=js"

import "./exportedSalesTable.vue?vue&type=style&index=0&id=e2d3c9c4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\taxes-calculator\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d3c9c4"]])

export default __exports__